import React from 'react';
import {useIntl} from "react-intl";

const QuizLiveAnswer:React.FC<{
  alphabet:string;
  answer: string;
  answerLength: number;
  totalAnswers?: number;
  totalAnswersAggregate?: number;
  value?: boolean;
}> = ({ alphabet, answer, answerLength, totalAnswers, value, totalAnswersAggregate }) => {
  const padClass = answerLength > 3 ? 'padClassActive' : '';
  const intl = useIntl();

  const ansClass = () => {
    if(totalAnswers?.toString()) {
      return value ? 'correct-ans' : 'wrong-ans'
    } else {
      return 'correct-ans'
    }
  }

  return (
    <div className={`quiz-live-answer-comp ${padClass} ${ansClass()}`}>
      <div className="l-ans-comp">
        <span className="alpha">{alphabet}<img className="correct-ans-img" src="/icons/ans-correct.svg" alt="" />
          <img className="wrong-ans-img" src="/icons/wrong-ans.svg" alt="" /></span>
        <p>{answer}</p>
      </div>
      {
        (totalAnswers && totalAnswersAggregate)
         ?
         <div className={`ans-poll `} >
          <div>
            <span>{ totalAnswers }</span>{intl.formatMessage({id: 'quiz.answers'})}
          </div>
        </div> :  <div className={`ans-poll `} >
              <div>
                <span>0</span>Answer
              </div>
            </div>
      }
    </div>
  )
}

export default QuizLiveAnswer
